import { render, staticRenderFns } from "./MaterialCard2.vue?vue&type=template&id=86299250&"
import script from "./MaterialCard2.vue?vue&type=script&lang=js&"
export * from "./MaterialCard2.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCard2.vue?vue&type=style&index=0&id=86299250&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports